import useDeviceWidth from '@/hooks/deviceWidth';
import useViewPortSize from '@/hooks/useViewportSize';
import TextLogo from '@/public/cmsAssets/assets/img/logo/TextLogo';
import { brandColors } from '@/styles/sunrunTheme.styles';
import {
  getFrontifyBackgroundImageUrl,
  MAX_IMAGE_WIDTH,
} from '@/utils/frontify';

import useStyles from './InteractiveQuoteForm.styles';
import ProgressBar from './ProgressBar';

interface Props {
  stepIndex: number;
  fullScreenImage?: string;
  rightHalfImage?: string;
  progressBarPercentage?: number;
  currentStepIndex: number;
  heading?: string;
  subheading?: string;
  formContent?: React.ReactElement;
}

export default function InteractiveQuoteFormScreen({
  stepIndex,
  fullScreenImage,
  rightHalfImage,
  progressBarPercentage,
  currentStepIndex,
  heading,
  subheading,
  formContent,
}: Props) {
  const { classes, cx } = useStyles();
  const { isTablet } = useDeviceWidth();
  const { isExtraSmall, isSmall } = useViewPortSize();
  const isMobile = isExtraSmall || isSmall;
  return (
    <div
      className={classes.container}
      style={{
        backgroundImage:
          fullScreenImage &&
          getFrontifyBackgroundImageUrl(fullScreenImage, MAX_IMAGE_WIDTH),
        // For abtasty purposes we are using "display: none" to hide the non-current steps instead of conditional rendering
        ...(currentStepIndex !== stepIndex && { display: 'none' }),
      }}
    >
      <div className={classes.leftHalfContainer}>
        {!isTablet && !isMobile && (
          <div className={classes.logoWrapper}>
            <TextLogo
              classname={classes.logo}
              color={brandColors.primaryMain}
              width='95'
            />
          </div>
        )}
        <div className={classes.contentContainer}>
          <div className={classes.innerContent}>
            <div>
              {progressBarPercentage && (
                <ProgressBar percentage={progressBarPercentage} />
              )}
              <div>
                {/* If there are too many changes needed for first landing page could refactor to a separate component */}
                {(isMobile || isTablet) && currentStepIndex === 1 && (
                  <div className={classes.landingLogo}>
                    <TextLogo
                      classname={classes.logo}
                      color={brandColors.primaryMain}
                      width='95'
                    />
                  </div>
                )}
                <h1 className={classes.heading}>{heading}</h1>
                {subheading && (
                  <h2 className={classes.subheading}>{subheading}</h2>
                )}
              </div>
            </div>
            <div
              className={cx([
                classes.formContainer,
                currentStepIndex === 1 && classes.landingFormContainer,
              ])}
            >
              {formContent}
            </div>
          </div>
        </div>
      </div>
      <div
        style={
          rightHalfImage
            ? {
                backgroundImage: getFrontifyBackgroundImageUrl(
                  rightHalfImage,
                  MAX_IMAGE_WIDTH
                ),
              }
            : {}
        }
        className={classes.rightHalfContainer}
      />
    </div>
  );
}
